"use strict";

const j = require("react/jsx-runtime"),
  t = require("react");
function b(_ref) {
  let {
    id: r,
    host: s,
    repo: i,
    repoId: u,
    category: n,
    categoryId: o,
    mapping: c,
    term: a,
    strict: d,
    reactionsEnabled: f,
    emitMetadata: l,
    inputPosition: m,
    theme: p,
    lang: g,
    loading: q
  } = _ref;
  const [e, x] = t.useState(!1);
  return t.useEffect(() => {
    e || (Promise.resolve().then(() => require("./giscus-1126a0a1.js")), x(!0));
  }, []), e ? j.jsx("giscus-widget", {
    id: r,
    host: s,
    repo: i,
    repoid: u,
    category: n,
    categoryid: o,
    mapping: c,
    term: a,
    strict: d,
    reactionsenabled: f,
    emitmetadata: l,
    inputposition: m,
    theme: p,
    lang: g,
    loading: q
  }) : null;
}
module.exports = b;